// extracted by mini-css-extract-plugin
export default {"root":"InstanceConfigModal_root__Qwecz","container":"InstanceConfigModal_container__UD4oD"};